import type { Rating } from '@ctct/domain-layer';

import type { TranslationGetter } from '../../../types';

export class SharedOrderItemsTranslationService {
  constructor(
    private t: TranslationGetter,
    private isStripeCustomer: boolean,
    private isNonProfit: boolean | undefined
  ) {}

  public getPeriodLabel(rating: Rating) {
    if (rating.getPaymentPeriod() === 1) {
      return this.t('application-layer.order-summary.monthly');
    }

    // Use subscription language for Stripe, prepay for BaaS
    if (this.isStripeCustomer) {
      return rating.getPaymentPeriod() === 12
        ? this.t('application-layer.order-summary.annual-subscription-period')
        : this.t('application-layer.order-summary.subscription-period', { months: rating.getPaymentPeriod() });
    }

    return this.t('application-layer.order-summary.prepay-period', { months: rating.getPaymentPeriod() });
  }

  public getSavingsDiscountKey() {
    if (this.isStripeCustomer) {
      return this.isNonProfit
        ? ('application-layer.order-summary.subscription-nonprofit-savings-discount' as const)
        : ('application-layer.order-summary.subscription-savings-discount' as const);
    }

    if (this.isNonProfit) {
      return 'application-layer.order-summary.prepay-nonprofit-savings-discount' as const;
    }

    return 'application-layer.order-summary.prepay-savings-discount' as const;
  }

  public getContactsTierLabel(tierMin: number, tierMax: number): string {
    if (tierMax < 0) {
      return this.t('application-layer.order-summary.contacts-plan-unlimited-secondary-label');
    }

    return this.t('application-layer.order-summary.contacts-plan-secondary-label', { tierMin, tierMax });
  }
}
